<template>
  <div
    v-loading="loading"
    :element-loading-text="loadingTitle"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <breadcrumbs></breadcrumbs>

    <div class="bg-white">
      <!-- 阶段二直接显示，没有步骤条 -->
      <div class="stageTwo pd-50">
        <p class="color0063ea f16 fw-600">设备配置信息完善</p>
        <div class="mgb-15 colorRed fw-600">
          温馨提示：为保证设备成功接收最新价格，请多保存几次本页信息。
        </div>

        <el-form
          :rules="stageTwoFormRules"
          ref="stageTwoForm"
          :model="stageTwoForm"
          label-width="100px"
        >
          <!-- 铺设场景（如果后续需要可取消注释） -->
          <!-- <el-form-item label="铺设场景" prop="sceneName">
            <el-select v-model="stageTwoForm.sceneName" placeholder="请选择铺设场景">
              <el-option v-for="(v, i) in changjingList" :key="i" :label="v.sceneName" :value="v.id"></el-option>
            </el-select>
          </el-form-item> -->

          <!-- 冷热温一体机设备模式（原有逻辑） -->
          <el-form-item
            label="设备模式"
            v-if="stageOneForm.dictName == '冷热温一体机'"
          >
            <el-button
              type="primary"
              @click="
                iceHotDialogVisible = true;
                iceHotForm = { name: '', model: [] };
              "
              >增加</el-button
            >
            <div class="lengrewenmoshi">
              <div
                class="iceHotModel"
                v-for="(v, i) in iceHotModelArr"
                :key="i"
              >
                <div class="cha" @click="removeModel(v)">X</div>
                <div class="nameTitle">{{ v.name }}</div>
                <div class="modelTitle">{{ v.model }}</div>
              </div>
            </div>
          </el-form-item>

          <!-- 冷热温一体机出水量及价格 -->
          <el-form-item
            label="出水量及价格"
            v-if="stageOneForm.dictName == '冷热温一体机'"
          >
            <el-tabs type="border-card">
              <el-tab-pane
                v-for="(v, i) in iceHotModelArr"
                :key="i"
                :label="v.name"
              >
                <div class="hotPrize bg-e2e2e2 pd-20">
                  <el-form-item label="参考价格">
                    <el-input
                      class="inp"
                      v-model="v.equipmentPrice"
                      placeholder="请输入售水价格"
                    ></el-input>
                    元/1000ml
                  </el-form-item>
                  <el-form-item label="出水量">
                    <div class="waterYield">
                      <el-form-item
                        v-for="(item, index) in v.futureEquipmentVerSkuPoJoList"
                        :key="index"
                        :label="'水量档' + (index + 1)"
                      >
                        <el-input
                          class="quantity"
                          v-model="item.equipmentSkuInfo"
                          @input="blurInputTree(item, v)"
                        ></el-input>
                        <el-select
                          v-model="item.radio"
                          placeholder="请选择"
                          @change="gethotPrizeTree(item, v)"
                        >
                          <el-option label="ML" value="ML"> </el-option>
                          <el-option label="L" value="L"> </el-option>
                        </el-select>
                        <i
                          class="el-icon-remove-outline colorf00 f16 cursor"
                          @click.prevent="removeHotTree(v, item)"
                        ></i>
                        <div
                          class="underline color0063ea"
                          v-if="item.equipmentSkuInfo"
                        >
                          <div class="mgr-30 flex aic">
                            <el-form-item label="价格：¥">
                              <el-input
                                disabled
                                class="eaitPrizeInp"
                                v-model="item.price"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <el-button
                          v-if="
                            index ==
                              v.futureEquipmentVerSkuPoJoList.length - 1 &&
                              v.futureEquipmentVerSkuPoJoList.length < 3
                          "
                          @click="addHotPrizeTree(v, item)"
                          type="primary"
                          >新增挡位</el-button
                        >
                      </el-form-item>
                    </div>
                  </el-form-item>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>

          <!-- ========= WLXS-RO-800 和 WLXS-RO-800-A 专用设备模式 ========= -->
          <template v-if="isWLXSRO800">
            <el-form-item label="设备模式" prop="equipmentModel">
              <el-checkbox-group v-model="stageTwoForm.equipmentModel">
                <el-checkbox label="纯净水"></el-checkbox>
                <el-checkbox label="富矿水"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <!-- 出水量及价格 - 纯净水和富矿水分两个 Tab -->
            <el-form-item label="出水量及价格">
              <el-tabs type="border-card">
                <!-- 纯净水 Tab -->
                <el-tab-pane
                  v-if="stageTwoForm.equipmentModel.indexOf('纯净水') != -1"
                  label="纯净水"
                >
                  <div class="hotPrize bg-e2e2e2 pd-20">
                    <el-form-item label="参考价格">
                      <el-input
                        class="inp"
                        v-model="stageTwoForm.hotWaterFrom.equipmentPrice"
                        placeholder="请输入售水价格"
                      ></el-input>
                      元/1000ml
                    </el-form-item>
                    <el-form-item label="出水量" required>
                      <div class="waterYield">
                        <el-form-item
                          v-for="(v, i) in stageTwoForm.hotWaterFrom
                            .futureEquipmentVerSkuPoJoList"
                          :key="i"
                          :label="'水量档' + (i + 1)"
                          :prop="
                            'hotWaterFrom.futureEquipmentVerSkuPoJoList.' +
                              i +
                              '.equipmentSkuInfo'
                          "
                          :rules="[
                            {
                              required: true,
                              message: '请输入正确水量',
                              trigger: 'change',
                            },
                          ]"
                        >
                          <el-input
                            class="quantity"
                            v-model="v.equipmentSkuInfo"
                            @input="blurInput(v)"
                          ></el-input>
                          <el-select
                            v-model="v.radio"
                            placeholder="请选择"
                            @change="gethotPrize(v)"
                          >
                            <el-option label="ML" value="ML"> </el-option>
                            <el-option label="L" value="L"> </el-option>
                          </el-select>
                          <i
                            class="el-icon-remove-outline colorf00 f16 cursor"
                            @click.prevent="removeHot(v)"
                          ></i>
                          <div
                            class="underline color0063ea"
                            v-if="v.equipmentSkuInfo"
                          >
                            <div class="mgr-30 flex aic">
                              <el-form-item label="价格：¥">
                                <el-input
                                  disabled
                                  class="eaitPrizeInp"
                                  v-model="v.price"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </el-form-item>
                        <el-button
                          v-if="
                            stageTwoForm.hotWaterFrom
                              .futureEquipmentVerSkuPoJoList.length < 3
                          "
                          @click="addHotPrize"
                          type="primary"
                          >新增挡位</el-button
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-tab-pane>

                <!-- 富矿水 Tab -->
                <el-tab-pane
                  v-if="stageTwoForm.equipmentModel.indexOf('富矿水') != -1"
                  label="富矿水"
                >
                  <div class="icePrize bg-e2e2e2 pd-20">
                    <el-form-item label="参考价格">
                      <el-input
                        class="inp"
                        v-model="stageTwoForm.iceWaterFrom.equipmentPrice"
                        placeholder="请输入售水价格"
                      ></el-input>
                      元/1000ml
                    </el-form-item>
                    <el-form-item label="出水量" required>
                      <div class="waterYield">
                        <el-form-item
                          v-for="(v, i) in stageTwoForm.iceWaterFrom
                            .futureEquipmentVerSkuPoJoList"
                          :key="i"
                          :label="'水量档' + (i + 1)"
                          :prop="
                            'iceWaterFrom.futureEquipmentVerSkuPoJoList.' +
                              i +
                              '.equipmentSkuInfo'
                          "
                          :rules="[
                            {
                              required: true,
                              message: '请输入正确水量',
                              trigger: 'change',
                            },
                          ]"
                        >
                          <el-input
                            class="quantity"
                            v-model="v.equipmentSkuInfo"
                            @input="blurInputIce(v)"
                          ></el-input>
                          <el-select
                            v-model="v.radio"
                            placeholder="请选择"
                            @change="geticePrize(v)"
                          >
                            <el-option label="ML" value="ML"> </el-option>
                            <el-option label="L" value="L"> </el-option>
                          </el-select>
                          <i
                            class="el-icon-remove-outline colorf00 f16 cursor"
                            @click.prevent="removeIce(v)"
                          ></i>
                          <div
                            class="underline color0063ea"
                            v-if="v.equipmentSkuInfo"
                          >
                            <div class="flex aic">
                              <el-form-item label="价格：¥">
                                <el-input
                                  disabled
                                  class="eaitPrizeInp"
                                  v-model="v.price"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </el-form-item>
                        <el-button
                          v-if="
                            stageTwoForm.iceWaterFrom
                              .futureEquipmentVerSkuPoJoList.length < 3
                          "
                          @click="addIcePrize"
                          type="primary"
                          >新增挡位</el-button
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </template>

          <!-- ========= 普通设备（非 WLXS-RO-800/A，非冷热温，非双出水）原有逻辑 ========= -->
          <template
            v-if="
              !isWLXSRO800 &&
                stageOneForm.dictName !== '冷热温一体机' &&
                stageOneForm.dictName !== '售水机双出水' &&
                stageOneForm.equipmentVersion !== 'WLXS-RO-800-S'
            "
          >
            <el-form-item label="设备模式" prop="equipmentModel">
              <el-checkbox-group v-model="stageTwoForm.equipmentModel">
                <el-checkbox label="常温/热水"></el-checkbox>
                <!-- 普通设备没有冰水选项 -->
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="出水量及价格">
              <el-tabs type="border-card">
                <el-tab-pane
                  v-if="stageTwoForm.equipmentModel.indexOf('常温/热水') != -1"
                  label="常温/热水"
                >
                  <div class="hotPrize bg-e2e2e2 pd-20">
                    <el-form-item label="参考价格">
                      <el-input
                        class="inp"
                        v-model="stageTwoForm.hotWaterFrom.equipmentPrice"
                        placeholder="请输入售水价格"
                      ></el-input>
                      元/1000ml
                    </el-form-item>
                    <el-form-item label="出水量" required>
                      <div class="waterYield">
                        <el-form-item
                          v-for="(v, i) in stageTwoForm.hotWaterFrom
                            .futureEquipmentVerSkuPoJoList"
                          :key="i"
                          :label="'水量档' + (i + 1)"
                          :prop="
                            'hotWaterFrom.futureEquipmentVerSkuPoJoList.' +
                              i +
                              '.equipmentSkuInfo'
                          "
                          :rules="[
                            {
                              required: true,
                              message: '请输入正确水量',
                              trigger: 'change',
                            },
                          ]"
                        >
                          <el-input
                            class="quantity"
                            v-model="v.equipmentSkuInfo"
                            @input="blurInput(v)"
                          ></el-input>
                          <el-select
                            v-model="v.radio"
                            placeholder="请选择"
                            @change="gethotPrize(v)"
                          >
                            <el-option label="ML" value="ML"> </el-option>
                            <el-option label="L" value="L"> </el-option>
                          </el-select>
                          <i
                            class="el-icon-remove-outline colorf00 f16 cursor"
                            @click.prevent="removeHot(v)"
                          ></i>
                          <div
                            class="underline color0063ea"
                            v-if="v.equipmentSkuInfo"
                          >
                            <div class="mgr-30 flex aic">
                              <el-form-item label="价格：¥">
                                <el-input
                                  disabled
                                  class="eaitPrizeInp"
                                  v-model="v.price"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </el-form-item>
                        <el-button
                          v-if="
                            stageTwoForm.hotWaterFrom
                              .futureEquipmentVerSkuPoJoList.length < 3
                          "
                          @click="addHotPrize"
                          type="primary"
                          >新增挡位</el-button
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </template>

          <!-- 双水路设备模式（原有逻辑，保持不动） -->
          <template
            v-if="
              stageOneForm.dictName == '售水机双出水' ||
                stageOneForm.equipmentVersion == 'WLXS-RO-800-S'
            "
          >
            <!-- 双水路设备模式选择等，此处省略因为原有代码已有，但当前需求不涉及 -->
            <!-- <el-button
              type="primary"
              @click="
                shuangDialogVisible = true;
                shuangForm = { name: '', model: '' };
              "
              >增加</el-button
            >
            <div class="flex aic fww">
              <div
                class="iceHotModel"
                v-for="(v, i) in shuangModelArr"
                :key="i"
              >
                <div class="cha" @click="removeShuangModel(v)">X</div>
                <div class="nameTitle">{{ v.name }}</div>
                <div class="modelTitle">{{ v.model }}</div>
              </div>
            </div> -->
            <el-form-item
              label="设备模式"
              v-if="
                stageOneForm.dictName == '售水机双出水' ||
                  stageOneForm.equipmentVersion == 'WLXS-RO-800-S'
              "
            >
              <el-button
                type="primary"
                @click="
                  shuangDialogVisible = true;
                  shuangForm = { name: '', model: '' };
                "
                >增加</el-button
              >
              <div class="flex aic fww">
                <div
                  class="iceHotModel"
                  v-for="(v, i) in shuangModelArr"
                  :key="i"
                >
                  <div class="cha" @click="removeShuangModel(v)">X</div>
                  <div class="nameTitle">{{ v.name }}</div>
                  <div class="modelTitle">{{ v.model }}</div>
                </div>
              </div>
            </el-form-item>

            <!-- 双水路出水量及价格 -->
            <el-form-item
              label="出水量及价格"
              v-if="
                stageOneForm.dictName == '售水机双出水' ||
                  stageOneForm.equipmentVersion == 'WLXS-RO-800-S'
              "
            >
              <el-tabs type="border-card">
                <el-tab-pane
                  v-if="shuangHaveArr.indexOf('水路一') != -1"
                  :label="stageTwoForm.hotWaterFrom.type"
                >
                  <div class="hotPrize bg-e2e2e2 pd-20">
                    <el-form-item label="参考价格">
                      <el-input
                        class="inp"
                        v-model="stageTwoForm.hotWaterFrom.equipmentPrice"
                        placeholder="请输入售水价格"
                      ></el-input>
                      元/1000ml
                    </el-form-item>
                    <el-form-item label="出水量">
                      <div class="waterYield">
                        <el-form-item
                          v-for="(v, i) in stageTwoForm.hotWaterFrom
                            .futureEquipmentVerSkuPoJoList"
                          :key="i"
                          :label="'水量档' + (i + 1)"
                        >
                          <el-input
                            class="quantity"
                            v-model="v.equipmentSkuInfo"
                            @input="blurInput(v)"
                          ></el-input>

                          <el-select
                            v-model="v.radio"
                            placeholder="请选择"
                            @change="gethotPrize(v)"
                          >
                            <el-option label="ML" value="ML"> </el-option>
                            <el-option label="L" value="L"> </el-option>
                          </el-select>
                          <i
                            class="el-icon-remove-outline colorf00 f16 cursor"
                            @click.prevent="removeHot(v)"
                          ></i>

                          <div
                            class="underline color0063ea"
                            v-if="v.equipmentSkuInfo"
                          >
                            <div class="mgr-30 flex aic">
                              <el-form-item label="价格：¥">
                                <el-input
                                  disabled
                                  class="eaitPrizeInp"
                                  v-model="v.price"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </el-form-item>
                        <el-button @click="addHotPrize" type="primary"
                          >新增挡位</el-button
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-tab-pane>

                <el-tab-pane
                  v-if="shuangHaveArr.indexOf('水路二') != -1"
                  :label="stageTwoForm.iceWaterFrom.type"
                >
                  <div class="icePrize bg-e2e2e2 pd-20">
                    <el-form-item label="参考价格">
                      <el-input
                        class="inp"
                        v-model="stageTwoForm.iceWaterFrom.equipmentPrice"
                        placeholder="请输入售水价格"
                      ></el-input>
                      元/1000ml
                    </el-form-item>
                    <el-form-item label="出水量">
                      <div class="waterYield">
                        <el-form-item
                          v-for="(v, i) in stageTwoForm.iceWaterFrom
                            .futureEquipmentVerSkuPoJoList"
                          :key="i"
                          :label="'水量档' + (i + 1)"
                        >
                          <el-input
                            class="quantity"
                            v-model="v.equipmentSkuInfo"
                            @input="blurInputIce(v)"
                          ></el-input>

                          <el-select
                            v-model="v.radio"
                            placeholder="请选择"
                            @change="geticePrize(v)"
                          >
                            <el-option label="ML" value="ML"> </el-option>
                            <el-option label="L" value="L"> </el-option>
                          </el-select>
                          <i
                            class="el-icon-remove-outline colorf00 f16 cursor"
                            @click.prevent="removeIce(v)"
                          ></i>
                          <div
                            class="underline color0063ea"
                            v-if="v.equipmentSkuInfo"
                          >
                            <div class="flex aic">
                              <el-form-item label="价格：¥">
                                <el-input
                                  disabled
                                  class="eaitPrizeInp"
                                  v-model="v.price"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                        </el-form-item>
                        <el-button @click="addIcePrize" type="primary"
                          >新增挡位</el-button
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </template>

          <el-form-item>
            <div class="flex jcsa">
              <el-button @click="cancelBtn">返回</el-button>
              <el-button @click="saveTwo('stageTwoForm')">保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 冷热温弹框 -->
    <el-dialog
      title="设备模式"
      :visible.sync="iceHotDialogVisible"
      width="30%"
      center
      top="45vh"
      :close-on-click-modal="false"
    >
      <el-form
        :rules="iceHotFormRules"
        ref="iceHotForm"
        :model="iceHotForm"
        label-width="80px"
      >
        <el-form-item label="模式名称" prop="name">
          <el-input
            placeholder="请输入模式名称"
            v-model="iceHotForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="支持模式" prop="model">
          <el-select
            multiple
            v-model="iceHotForm.model"
            placeholder="请选择模式"
          >
            <el-option label="冰水" value="冰水"></el-option>
            <el-option label="常温水" value="常温水"></el-option>
            <el-option label="55℃" value="55℃"></el-option>
            <el-option label="85℃" value="85℃"></el-option>
            <el-option label="100℃" value="100℃"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="iceHotDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="addIceHotModel('iceHotForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 双出水弹框 -->
    <el-dialog
      title="设备模式"
      :visible.sync="shuangDialogVisible"
      width="30%"
      center
      top="45vh"
      :close-on-click-modal="false"
    >
      <el-form
        :rules="shuangFormRules"
        ref="shuangForm"
        :model="shuangForm"
        label-width="80px"
      >
        <el-form-item label="水路名称" prop="name">
          <el-input
            placeholder="请输入水路名称"
            v-model="shuangForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="水路" prop="model">
          <el-select v-model="shuangForm.model" placeholder="请选择水路">
            <el-option label="水路一" value="水路一"></el-option>
            <el-option label="水路二" value="水路二"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="shuangDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="addshuangModel('shuangForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    const danjia = (rule, value, callback) => {
      let reg = /^(0\.[1-9]\d?|1(\.00?)?)$/;
      if (!value) {
        callback(new Error("请输入单价"));
      } else if (!reg.test(value)) {
        callback(
          new Error("仅支持输入数字，范围在0.1到1之间，最多保留两位小数"),
        );
      } else {
        callback();
      }
    };

    return {
      // ... 原有 data 属性保持不变 ...
      pickerOptionsEnd: {},
      imgList: [],
      dialogVisible: false,
      changeHeadImgform: { headUrl: "" },
      activeName: "first",
      active: 1,
      steps: [],
      stageOneForm: {
        equipmentVersion: "",
        equipmentNum: "",
        createTime: "",
        companyName: "",
        typeName: "购买",
        shareRatio: "",
        guishu: "",
        dictName: "",
      },
      stageOneFormRules: {},
      stageTwoForm: {
        sceneName: "",
        waterModel: [],
        equipmentModel: [],
        hotWaterFrom: {
          type: "常温/热水",
          equipmentPrice: "",
          futureEquipmentVerSkuPoJoList: [],
        },
        iceWaterFrom: {
          type: "冰水",
          equipmentPrice: "",
          futureEquipmentVerSkuPoJoList: [],
        },
        iceTemperature: "5",
        hotTemperature: "40",
        id: "",
      },
      stageTwoFormRules: {
        equipmentModel: [
          { required: true, message: "请选择设备模式", trigger: "change" },
        ],
        "hotWaterFrom.equipmentPrice": [
          { required: true, validator: danjia, trigger: "change" },
        ],
        "iceWaterFrom.equipmentPrice": [
          { required: true, validator: danjia, trigger: "change" },
        ],
      },
      // ... 其他原有属性 ...
      guishuList: [],
      changjingList: [],
      buyWaterList: [],
      dictIdsArr: [],
      id: "",
      futureCustomerId: null,
      dataInfo: null,
      iceHotDialogVisible: false,
      iceHotForm: { name: "", model: [] },
      iceHotFormRules: {},
      iceHotModelArr: [],
      shuangDialogVisible: false,
      shuangForm: { name: "", model: "" },
      shuangFormRules: {},
      shuangModelArr: [],
      shuangHaveArr: [],
      ratio: null,
      loading: false,
      loadingTitle: "参数下发中，请稍等...",
      priceTimer: null,
      priceTimerCount: 0,
    };
  },
  computed: {
    // 判断是否为 WLXS-RO-800 或 WLXS-RO-800-A
    isWLXSRO800() {
      return (
        this.stageOneForm.equipmentVersion === "WLXS-RO-800" ||
        this.stageOneForm.equipmentVersion === "WLXS-RO-800-A"
      );
    },
  },
  watch: {
    "stageOneForm.startTime"() {
      if (this.stageOneForm.startTime == null) {
        this.stageOneForm.endTime = null;
      }
    },
  },
  created() {
    this.futureCustomerId = this.$route.query.list.futureCustomerId;
    this.stageOneForm = this.$route.query.list;
    this.ratio = this.$route.query.list.ratio;
    this.dataInfo = this.$route.query.list;
    this.stageTwoForm.id = this.$route.query.list.id;
    this.id = this.$route.query.list.id;
    this.stageTwoForm.sceneName = this.$route.query.list.sceneName;

    console.log("设备详情", this.stageOneForm);

    // this.stageOneForm.equipmentVersion='WLXS-RO-800-S'

    // 加载滤芯列表等基础数据
    this.getlvxin();

    // 回显设备配置数据
    // 根据设备类型选择不同的回显方式
    if (
      this.stageOneForm.dictName == "售水机双出水" ||
      this.stageOneForm.equipmentVersion == "WLXS-RO-800-S"
    ) {
      // 双出水设备：直接解析 futureEquipmentVerSkuBeans
      this.initShuangFromData();
    } else {
      // 普通设备
      this.loadExistingData();
    }
  },
  methods: {
    initShuangFromData() {
      const skuBeans = this.stageOneForm.futureEquipmentVerSkuBeans || [];

      if (skuBeans.length === 0) {
        // 没有数据时初始化空档位
        this.initEmptyShuangData();
        return;
      }

      // 按 waterNum 分组（水路一=1，水路二=2）
      const water1List = []; // 水路一（纯净水/常温热水）
      const water2List = []; // 水路二（富矿水/冰水）

      skuBeans.forEach((item) => {
        let skuInfo;
        try {
          skuInfo = JSON.parse(item.equipmentSkuInfo);
        } catch (e) {
          skuInfo = {
            waterNum: 1,
            出水量: item.equipmentSkuInfo,
            价格: item.price,
          };
        }

        const waterItem = {
          equipmentSkuInfo: skuInfo.出水量,
          price: item.price,
          radio: item.capacityType || "L",
          equipmentPrice: item.equipmentPrice,
          type: item.type,
        };

        if (skuInfo.waterNum == 1) {
          water1List.push(waterItem);
        } else if (skuInfo.waterNum == 2) {
          water2List.push(waterItem);
        }
      });

      // 设置水路一的数据（热水/常温/纯净水）
      if (water1List.length > 0) {
        this.shuangHaveArr.push("水路一");
        this.stageTwoForm.hotWaterFrom.type = water1List[0].type || "水路一";
        this.stageTwoForm.hotWaterFrom.equipmentPrice =
          water1List[0].equipmentPrice;
        this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList = water1List.map(
          (item) => ({
            equipmentSkuInfo: item.equipmentSkuInfo,
            price: item.price,
            radio: item.radio,
            key: Date.now() + Math.random(),
          }),
        );

        // 添加到 shuangModelArr 用于显示
        this.shuangModelArr.push({
          name: water1List[0].type || "水路一",
          model: "水路一",
          equipmentPrice: water1List[0].equipmentPrice,
          futureEquipmentVerSkuPoJoList: water1List,
        });
      } else {
        // 没有水路一数据时初始化空档位
        this.initEmptyWater1();
      }

      // 设置水路二的数据（冰水/富矿水）
      if (water2List.length > 0) {
        this.shuangHaveArr.push("水路二");
        this.stageTwoForm.iceWaterFrom.type = water2List[0].type || "水路二";
        this.stageTwoForm.iceWaterFrom.equipmentPrice =
          water2List[0].equipmentPrice;
        this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList = water2List.map(
          (item) => ({
            equipmentSkuInfo: item.equipmentSkuInfo,
            price: item.price,
            radio: item.radio,
            key: Date.now() + Math.random(),
          }),
        );

        // 添加到 shuangModelArr 用于显示
        this.shuangModelArr.push({
          name: water2List[0].type || "水路二",
          model: "水路二",
          equipmentPrice: water2List[0].equipmentPrice,
          futureEquipmentVerSkuPoJoList: water2List,
        });
      } else {
        // 没有水路二数据时初始化空档位
        this.initEmptyWater2();
      }

      // 回显设备模式（如果有 types 字段）
      if (this.stageOneForm.types) {
        const typeArr = this.stageOneForm.types.split(",");
        this.stageTwoForm.equipmentModel = typeArr;
      }

      console.log("双出水回显完成", {
        shuangModelArr: this.shuangModelArr,
        shuangHaveArr: this.shuangHaveArr,
        hotWaterFrom: this.stageTwoForm.hotWaterFrom,
        iceWaterFrom: this.stageTwoForm.iceWaterFrom,
      });
    },
    loadExistingData() {
      const equipmentData = this.dataInfo;

      // 如果是 WLXS-RO-800/A，从 futureEquipmentVerSkuBeans 中读取纯净水和富矿水数据
      if (this.isWLXSRO800) {
        // 设备模式回显
        if (equipmentData.types) {
          this.stageTwoForm.equipmentModel = equipmentData.types.split(",");
        } else {
          this.stageTwoForm.equipmentModel = [];
        }

        // 清空现有档位
        this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList = [];
        this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList = [];

        // 遍历 futureEquipmentVerSkuBeans 填充档位
        if (
          equipmentData.futureEquipmentVerSkuBeans &&
          equipmentData.futureEquipmentVerSkuBeans.length
        ) {
          equipmentData.futureEquipmentVerSkuBeans.forEach((item) => {
            let obj;
            try {
              obj = JSON.parse(item.equipmentSkuInfo);
            } catch (e) {
              obj = { 出水量: item.equipmentSkuInfo, 价格: item.price };
            }
            const waterItem = {
              equipmentSkuInfo: obj.出水量,
              price: obj.价格,
              radio: item.capacityType || "L",
              source: item.source,
              key: Date.now() + Math.random(),
            };
            if (item.type === "纯净水") {
              this.stageTwoForm.hotWaterFrom.equipmentPrice =
                item.equipmentPrice;
              this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.push(
                waterItem,
              );
            } else if (item.type === "富矿水") {
              this.stageTwoForm.iceWaterFrom.equipmentPrice =
                item.equipmentPrice;
              this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.push(
                waterItem,
              );
            }
          });
        }

        // 如果没有数据，初始化默认三个空档位
        if (
          !this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.length
        ) {
          for (let i = 0; i < 3; i++) {
            this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.push({
              equipmentSkuInfo: "",
              price: "",
              radio: "L",
              key: Date.now() + i,
            });
          }
        }
        if (
          !this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.length
        ) {
          for (let i = 0; i < 3; i++) {
            this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.push({
              equipmentSkuInfo: "",
              price: "",
              radio: "L",
              key: Date.now() + i + 100,
            });
          }
        }
      } else {
        // 普通设备回显（原有逻辑，从 futureEquipmentVerSkuBeans 读取常温/热水）
        if (
          equipmentData.futureEquipmentVerSkuBeans &&
          equipmentData.futureEquipmentVerSkuBeans.length
        ) {
          this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList = [];
          equipmentData.futureEquipmentVerSkuBeans.forEach((item) => {
            if (item.type === "常温/热水") {
              let obj;
              try {
                obj = JSON.parse(item.equipmentSkuInfo);
              } catch (e) {
                obj = { 出水量: item.equipmentSkuInfo, 价格: item.price };
              }
              this.stageTwoForm.hotWaterFrom.equipmentPrice =
                item.equipmentPrice;
              this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.push(
                {
                  equipmentSkuInfo: obj.出水量,
                  price: obj.价格,
                  radio: item.capacityType || "L",
                  source: item.source,
                  key: Date.now(),
                },
              );
            }
          });
          if (
            !this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.length
          ) {
            this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.push({
              equipmentSkuInfo: "",
              price: "",
              radio: "L",
              key: Date.now(),
            });
          }
        } else {
          this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList = [
            { equipmentSkuInfo: "", price: "", radio: "L", key: Date.now() },
          ];
        }
        // 设备模式默认常温/热水
        if (!this.stageTwoForm.equipmentModel.length) {
          this.stageTwoForm.equipmentModel = ["常温/热水"];
        }
      }
    },
    getShuang() {
      this.shuangModelArr = [];
      this.shuangModelArr = this.transformDataShuang(
        this.dataInfo.waterPriceList,
      );
      this.shuangHaveArr = [];

      console.log(this.shuangModelArr, "this.shuangModelArr胡晶辉");

      this.shuangModelArr.forEach((v) => {
        if (v.model.includes("水路一")) {
          this.shuangHaveArr.push("水路一");
          this.stageTwoForm.hotWaterFrom.type = v.name;
          this.stageTwoForm.hotWaterFrom.equipmentPrice = v.equipmentPrice;

          this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList =
            v.futureEquipmentVerSkuPoJoList;
        } else if (v.model.includes("水路二")) {
          this.shuangHaveArr.push("水路二");
          this.stageTwoForm.iceWaterFrom.type = v.name;
          this.stageTwoForm.iceWaterFrom.equipmentPrice = v.equipmentPrice;
          this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList =
            v.futureEquipmentVerSkuPoJoList;
          // this.stageTwoForm.iceWaterFrom = {
          //   type: v.name,
          //   equipmentPrice: v.equipmentPrice,
          //   futureEquipmentVerSkuPoJoList: v.futureEquipmentVerSkuPoJoList,
          // };
        }
      });
    },

    transformData(data) {
      const result = [];
      const tempMap = new Map();

      for (const key in data) {
        data[key].forEach((item) => {
          const equipmentSkuInfo = JSON.parse(item.equipmentSkuInfo);
          const existingItem = tempMap.get(item.type);

          if (existingItem) {
            existingItem.futureEquipmentVerSkuPoJoList.push({
              equipmentSkuInfo: equipmentSkuInfo.出水量,
              price: equipmentSkuInfo.价格,
              radio: item.capacityType,
            });
          } else {
            tempMap.set(item.type, {
              name: key,
              model: equipmentSkuInfo.模式,
              equipmentPrice: item.equipmentPrice,
              type: item.type,
              futureEquipmentVerSkuPoJoList: [
                {
                  equipmentSkuInfo: parseInt(equipmentSkuInfo.出水量),
                  price: equipmentSkuInfo.价格,
                  radio: item.capacityType,
                },
              ],
            });
          }
        });
      }

      for (const item of tempMap.values()) {
        result.unshift(item);
      }

      return result;
    },

    transformDataShuang(data) {
      const result = [];
      const tempMap = new Map();

      for (const key in data) {
        data[key].forEach((item) => {
          const equipmentSkuInfo = JSON.parse(item.equipmentSkuInfo);
          console.log(
            equipmentSkuInfo,
            "equipmentSkuInfoequipmentSkuInfoequipmentSkuInfo",
          );

          const existingItem = tempMap.get(item.type);

          console.log(existingItem, "existingItemexistingItemexistingItem");

          if (existingItem) {
            existingItem.futureEquipmentVerSkuPoJoList.push({
              equipmentSkuInfo: equipmentSkuInfo.出水量,
              price: equipmentSkuInfo.价格,
              radio: item.capacityType,
            });
          } else {
            tempMap.set(item.type, {
              name: key,
              model:
                equipmentSkuInfo.waterNum == 1
                  ? "水路一"
                  : equipmentSkuInfo.waterNum == 2
                  ? "水路二"
                  : "- -",
              equipmentPrice: item.equipmentPrice,
              type: item.type,
              futureEquipmentVerSkuPoJoList: [
                {
                  equipmentSkuInfo: equipmentSkuInfo.出水量,
                  price: equipmentSkuInfo.价格,
                  radio: item.capacityType,
                },
              ],
            });
          }
        });
      }

      for (const item of tempMap.values()) {
        result.unshift(item);
      }

      console.log(result, "resultresultresultresultresult");

      return result;
    },

    // 删除双水路模式
    removeShuangModel(v) {
      var index = this.shuangModelArr.indexOf(v);
      var index2 = this.shuangHaveArr.indexOf(v.model);
      handleConfirm("确认删除该水路吗?", "info")
        .then(() => {
          if (index !== -1) {
            this.shuangModelArr.splice(index, 1);
          }
          if (index2 !== -1) {
            this.shuangHaveArr.splice(index2, 1);
            console.log(this.shuangHaveArr);
          }
        })
        .catch(() => {
          return;
        });
    },

    // 双出水选择水路
    addshuangModel(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          let a = [];
          this.shuangModelArr.forEach((v) => {
            if (v.model.includes(this.shuangForm.model)) {
              a.push(v);
            }
          });
          if (a.length !== 0) {
            handleAlert("已包含此水路，请重新选择", "error");
            return;
          }
          handleConfirm("确认新增该水路吗?", "info")
            .then(() => {
              this.shuangModelArr.push({
                name: this.shuangForm.name,
                model: this.shuangForm.model,
                equipmentPrice: 0,
                type: this.shuangForm.name,
                futureEquipmentVerSkuPoJoList: [
                  { equipmentSkuInfo: "", radio: "", price: "" },
                ],
              });
              this.shuangHaveArr = [];
              this.shuangModelArr.forEach((v) => {
                if (v.model.includes("水路一")) {
                  this.shuangHaveArr.push("水路一");
                  this.stageTwoForm.hotWaterFrom.type = v.name;
                } else if (v.model.includes("水路二")) {
                  this.shuangHaveArr.push("水路二");
                  this.stageTwoForm.iceWaterFrom.type = v.name;
                }
              });
              this.shuangDialogVisible = false;
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 冷热温选择模式
    addIceHotModel(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          let a = [];
          this.iceHotModelArr.forEach((v) => {
            if (v.name.includes(this.iceHotForm.name)) {
              a.push(v);
            }
          });
          if (a.length !== 0) {
            handleAlert("名字不能重复，请重新输入", "error");
            return;
          }
          handleConfirm("确认新增该模式吗?", "info")
            .then(() => {
              this.iceHotModelArr.push({
                name: this.iceHotForm.name,
                model: this.iceHotForm.model.join("、"),
                equipmentPrice: 0,
                type: this.iceHotForm.name,
                futureEquipmentVerSkuPoJoList: [
                  { equipmentSkuInfo: "", radio: "", price: "" },
                ],
              });
              this.iceHotDialogVisible = false;
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },

    // 购水模式
    getbuyWater() {
      this.$api.shebei.dictList({ dictName: "购水模式" }).then((res) => {
        this.buyWaterList = res.data[0].futureSysDictBeans;
      });
      setTimeout(() => {
        this.getwaterSku();
      }, 1000);
    },

    // 删除档位
    removeHotTree(v, item) {
      handleConfirm("确认删除水量档吗", "warning")
        .then(() => {
          var index = v.futureEquipmentVerSkuPoJoList.indexOf(item);
          // var index;
          // this.iceHotModelArr.forEach((item) => {
          //   index = item.futureEquipmentVerSkuPoJoList.indexOf(v);
          // });
          if (index !== 0) {
            v.futureEquipmentVerSkuPoJoList.splice(index, 1);
            // this.iceHotModelArr.forEach((item) => {
            //   item.futureEquipmentVerSkuPoJoList.splice(index, 1);
            // });
            handleAlert("水量档删除成功", "success");
          }
          if (index == 0) {
            this.$message.error("至少保留一个档位！");
          }
        })
        .catch(() => {
          handleAlert("取消删除", "error");
        });
    },

    getwaterSku() {
      this.stageTwoForm.sceneName = this.$route.query.list.sceneName;
      if (
        this.dataInfo.dictName !== "售水机双出水" &&
        this.stageOneForm.equipmentVersion !== "WLXS-RO-800-S"
      ) {
        this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList = [];
        this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList = [];
        this.$route.query.list.futureEquipmentVerSkuBeans.forEach((v) => {
          let obj = JSON.parse(v.equipmentSkuInfo);
          v.equipmentSkuInfo = obj.出水量;
          v.radio = v.capacityType;
          v.source = this.$route.query.source;
          if (v.type == "常温/热水") {
            this.stageTwoForm.hotWaterFrom.equipmentPrice = v.equipmentPrice;
            this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.push(
              v,
            );
          } else if (v.type == "冰水") {
            this.stageTwoForm.iceWaterFrom.equipmentPrice = v.equipmentPrice;

            this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.push(
              v,
            );
          }
        });
      }
      if (this.$route.query.list.pattern) {
        let modelArr = this.$route.query.list.pattern.split(",");
        this.buyWaterList.map((v1) => {
          modelArr.forEach((v2) => {
            if (v1.dictId == v2) {
              this.stageTwoForm.waterModel.push(v1.dictName);
              this.dictIdsArr.push(v1.dictId);
            }
          });
        });
      }

      if (this.$route.query.list.types) {
        console.log("来了");
        let eqmodelArr = this.$route.query.list.types.split(",");

        // this.shebeiModelList.map((v1) => {
        eqmodelArr.forEach((v2) => {
          console.log(v2, "v2");
          if (v2 == "常温/热水") {
            this.stageTwoForm.equipmentModel.push("常温/热水");
            // this.shebeiModelArr.push(v1.dictId);
          } else if (v2 == "冰水") {
            this.stageTwoForm.equipmentModel.push("冰水");
          }
        });
        // });
      }
    },

    // 第一阶段合计和剩余天数换算
    // getDays() {
    //   let startTime = new Date(this.stageOneForm.startTime).getTime();
    //   let endTime = new Date(this.stageOneForm.endTime).getTime();
    //   this.stageOneForm.totalDays = parseInt(
    //     Math.abs((startTime - endTime) / (24 * 60 * 60 * 1000))
    //   );
    //   let nowTime = new Date().getTime();
    //   this.stageOneForm.resDays = parseInt(
    //     Math.abs((endTime - nowTime) / (24 * 60 * 60 * 1000))
    //   );
    // },

    blurInput(v) {
      if (v.radio === "ML") v.radio = "ML";
      else v.radio = "L";
      this.gethotPrize(v);
    },
    blurInputTree(v, item) {
      if (v.radio == "ML") {
        v.radio = "ML";
      } else {
        v.radio = "L";
      }
      this.gethotPrizeTree(v, item);
    },

    blurInputIce(v) {
      if (v.radio === "ML") v.radio = "ML";
      else v.radio = "L";
      this.geticePrize(v);
    },

    gethotPrizeTree(v, item) {
      this.$forceUpdate();
      if (v.radio === "ML") {
        v.price = ((v.equipmentSkuInfo / 1000) * item.equipmentPrice).toFixed(
          1,
        );
      } else {
        if (v.source === "未来先生一") {
          v.price = (v.equipmentSkuInfo * item.equipmentPrice).toFixed(1);
        } else {
          v.price = (v.equipmentSkuInfo * item.equipmentPrice).toFixed(2);
        }
      }
    },

    gethotPrize(v) {
      if (v.radio === "ML") {
        v.price = (
          (v.equipmentSkuInfo / 1000) *
          this.stageTwoForm.hotWaterFrom.equipmentPrice
        ).toFixed(2);
      } else {
        v.price = (
          v.equipmentSkuInfo * this.stageTwoForm.hotWaterFrom.equipmentPrice
        ).toFixed(2);
      }
    },
    geticePrize(v) {
      if (v.radio === "ML") {
        v.price = (
          (v.equipmentSkuInfo / 1000) *
          this.stageTwoForm.iceWaterFrom.equipmentPrice
        ).toFixed(2);
      } else {
        v.price = (
          v.equipmentSkuInfo * this.stageTwoForm.iceWaterFrom.equipmentPrice
        ).toFixed(2);
      }
    },
    // 第一阶段保存
    saveOne(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.oneSave();
        } else {
          return false;
        }
      });
    },

    oneSave() {
      let guishuId = "";
      let reg = /^[0-9]*$/;
      if (reg.test(this.stageOneForm.companyName)) {
        guishuId = this.stageOneForm.companyName;
      } else {
        this.guishuList.forEach((v) => {
          if (this.stageOneForm.companyName == v.companyName) {
            guishuId = v.id;
          }
        });
      }
      this.$api.shebei
        .addEquipmentInfos({
          futureEquipmentVersionName: this.stageOneForm
            .futureEquipmentVersionName,
          equipmentNum: this.stageOneForm.equipmentNum,
          createTime: this.stageOneForm.createTime,
          futureCustomerId: guishuId,
          type: this.stageOneForm.typeName === "租赁" ? 0 : 1,
          startTime:
            this.stageOneForm.typeName == "购买" ? "" : this.getCurrentDate(),
          endTime:
            this.stageOneForm.typeName == "购买"
              ? ""
              : this.getCurrentDate100(),
          shareRatio: this.ratio,
          id: this.stageOneForm.id,
        })
        .then((res) => {
          if (res.code === 200) {
            // setTimeout(() => {
            //   this.xiafa();
            // }, 300);
            handleAlert("保存成功", "success");
          }
        });
    },

    xiafa() {
      let guishu = "";
      let reg = /^[0-9]*$/;
      if (reg.test(this.stageOneForm.companyName)) {
        guishu = this.stageOneForm.companyName;
      } else {
        this.guishuList.forEach((v) => {
          if (this.stageOneForm.companyName == v.companyName) {
            guishu = v.id;
          }
        });
      }
      let id = this.id;
      let ids = [];
      ids.push(id);
      // this.$api.shebei
      // .issueunbundle({
      //   shareRatio: this.stageOneForm.shareRatio,
      //   ids: ids,
      //   type: this.stageOneForm.typeName === "租赁" ? 0 : 1,
      //   afterFutureCustomerId: guishu,
      //   nowFutureCustomerId: this.$route.query.list.futureCustomerId,
      //   startTime: this.stageOneForm.startTime,
      //   endTime: this.stageOneForm.endTime,
      // })
      // .then((res) => {
      //   if (res.code === 200) {
      //     handleAlert("保存成功", "success");
      //   }
      // });
    },

    formatSkuInfo(skuInfo, equipmentVersion, isFirstArray) {
      let waterNum = 1; // 默认值

      // 判断 equipmentVersion 和数组来源
      if (
        equipmentVersion === "售水机双出水" ||
        this.stageOneForm.equipmentVersion == "WLXS-RO-800-S"
      ) {
        if (isFirstArray) {
          waterNum = 1; // 第一个数组
        } else {
          waterNum = 2; // 第二个数组
        }
      }

      return JSON.stringify({
        出水量: skuInfo["equipmentSkuInfo"] || "0",
        type: skuInfo["type"] || "未知",
        价格: skuInfo["price"] || 0.0,
        模式: skuInfo["type"] || "未知模式",
        waterNum: waterNum, // 新增的字段
      });
    },

    convertData(dataArray, equipmentVersion, isFirstArray) {
      if (!dataArray) return []; // 如果数组为 null，返回空数组
      console.log(dataArray, "dataArray");
      return dataArray.map((item) => ({
        capacityType: item.capacityType,
        equipmentId: item.equipmentId,
        equipmentPrice: item.equipmentPrice,
        equipmentSkuInfo: this.formatSkuInfo(
          item,
          equipmentVersion,
          isFirstArray,
        ),
        id: item.equipmentId, // 假设 id 是 equipmentId，原示例中有不同
        price: item.price,
        type: item.type, // 将类型中的斜杠去掉
      }));
    },

    mergeArrays(arr1, arr2, equipmentVersion) {
      if (!arr1 && !arr2) return []; // 如果两个数组都为 null，返回空数组
      if (!arr1) return this.convertData(arr2, equipmentVersion, false); // 如果第一个数组为 null，转换第二个数组
      if (!arr2) return this.convertData(arr1, equipmentVersion, true); // 如果第二个数组为 null，转换第一个数组

      // 两个数组都不为 null，先转换后合并
      const combined = this.convertData(arr1, equipmentVersion, true).concat(
        this.convertData(arr2, equipmentVersion, false),
      );

      // 去重逻辑：根据 equipmentId 和 price 去重
      // const uniqueMap = new Map();
      // combined.forEach((item) => {
      //   const key = `${item.equipmentId}-${item.price}`;
      //   if (!uniqueMap.has(key)) {
      //     uniqueMap.set(key, item);
      //   }
      // });

      return Array.from(combined.values());
    },

    // 冷热温
    transformDataIceHot(data) {
      return data.flatMap((item) =>
        item.futureEquipmentVerSkuPoJoList.map((sku) => ({
          capacityType: sku.radio, // 这里取 sku 的 radio 作为 capacityType
          equipmentId: this.$route.query.list.id, // 根据你的期望结果使用固定的 ID
          equipmentPrice: item.equipmentPrice, // 使用外部对象的 equipmentPrice
          equipmentSkuInfo: JSON.stringify({
            出水量: sku.equipmentSkuInfo,
            type: item.type,
            价格: sku.price,
            模式: item.model,
            waterNum: item.model,
          }),
          id: 12669, // 根据你的期望结果使用固定的 ID
          price: sku.price, // SKU 的价格
          type: item.type, // SKU 所属的类型
        })),
      );
    },
    // 第二阶段保存
    saveTwo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 准备保存的数据
          let saveData = [];

          let arr1 = [];
          let arr2 = [];


          if (this.isWLXSRO800) {
            // 处理纯净水档位
            if (this.stageTwoForm.equipmentModel.indexOf("纯净水") !== -1) {
              const pureList = this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.map(
                (item) => ({
                  capacityType: item.radio,
                  equipmentId: this.id,
                  equipmentPrice: this.stageTwoForm.hotWaterFrom.equipmentPrice,
                  equipmentSkuInfo: JSON.stringify({
                    出水量: item.equipmentSkuInfo,
                    type: "纯净水",
                    价格: item.price,
                    waterNum: 1,
                  }),
                  price: item.price,
                  type: "纯净水",
                  source: "未来先生二",
                }),
              );
              saveData.push(...pureList);
            }
            // 处理富矿水档位
            if (this.stageTwoForm.equipmentModel.indexOf("富矿水") !== -1) {
              const mineralList = this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.map(
                (item) => ({
                  capacityType: item.radio,
                  equipmentId: this.id,
                  equipmentPrice: this.stageTwoForm.iceWaterFrom.equipmentPrice,
                  equipmentSkuInfo: JSON.stringify({
                    出水量: item.equipmentSkuInfo,
                    type: "富矿水",
                    价格: item.price,
                    waterNum: 2,
                  }),
                  price: item.price,
                  type: "富矿水",
                  source: "未来先生二",
                }),
              );
              saveData.push(...mineralList);
            }
          } else if (this.stageOneForm.dictName == "冷热温一体机") {
            saveData.dictName = "冷热温一体机";
            saveData.waterFroms = this.iceHotModelArr;
          } else if (
            this.stageOneForm.dictName == "售水机双出水" ||
            this.stageOneForm.equipmentVersion == "WLXS-RO-800-S"
          ) {
            // console.log("售水机双出水", this.stageOneForm);
            this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.forEach(
              (v) => {
                v.capacityType = v.radio;
                v.equipmentId = this.$route.query.list.id;
                v.equipmentPrice = this.stageTwoForm.hotWaterFrom.equipmentPrice;
                v.source = "未来先生二";
                v.type = this.stageTwoForm.hotWaterFrom.type;
              },
            );
            this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.forEach(
              (v) => {
                v.capacityType = v.radio;
                v.equipmentId = this.$route.query.list.id;
                v.equipmentPrice = this.stageTwoForm.iceWaterFrom.equipmentPrice;
                v.source = "未来先生二";
                v.type = this.stageTwoForm.iceWaterFrom.type;
              },
            );
            arr1 =
            (this.stageTwoForm.equipmentModel.indexOf("常温/热水") != -1 &&
              this.stageOneForm.dictName !== "售水机双出水" &&
              this.stageOneForm.equipmentVersion !== "WLXS-RO-800-S") ||
            (this.shuangHaveArr.indexOf("水路一") != -1 &&
              (this.stageOneForm.dictName == "售水机双出水" ||
                this.stageOneForm.equipmentVersion == "WLXS-RO-800-S"))
              ? this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList
              : null;
          if (arr1 && arr1.length > 0) {
            arr1.forEach((v) => {
              v.equipmentPrice = this.stageTwoForm.hotWaterFrom.equipmentPrice;
            });
          }
          arr2 =
            (this.stageTwoForm.equipmentModel.indexOf("冰水") != -1 &&
              this.stageOneForm.dictName !== "售水机双出水" &&
              this.stageOneForm.equipmentVersion !== "WLXS-RO-800-S") ||
            (this.shuangHaveArr.indexOf("水路二") != -1 &&
              (this.stageOneForm.dictName == "售水机双出水" ||
                this.stageOneForm.equipmentVersion == "WLXS-RO-800-S"))
              ? this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList
              : null;
          if (arr2 && arr2.length > 0) {
            arr2.forEach((v) => {
              v.equipmentPrice = this.stageTwoForm.iceWaterFrom.equipmentPrice;
            });
          }
          saveData=[...this.mergeArrays(arr1, arr2, this.stageOneForm.dictName)]

            // if (this.shuangHaveArr.indexOf("水路一") != -1) {
            //   saveData.hotWaterFrom = this.stageTwoForm.hotWaterFrom;
            // }
            // if (this.shuangHaveArr.indexOf("水路二") != -1) {
            //   saveData.iceWaterFrom = this.stageTwoForm.iceWaterFrom;
            // }
          } else {
            // 普通设备处理常温/热水档位
            const hotList = this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.map(
              (item) => ({
                capacityType: item.radio,
                equipmentId: this.id,
                equipmentPrice: this.stageTwoForm.hotWaterFrom.equipmentPrice,
                equipmentSkuInfo: JSON.stringify({
                  出水量: item.equipmentSkuInfo,
                  type: "常温/热水",
                  价格: item.price,
                  waterNum: 1,
                }),
                price: item.price,
                type: "常温/热水",
                source: "未来先生二",
              }),
            );
            saveData.push(...hotList);
          }

          // 调用保存接口
          this.$api.shebei.savePriceEdit(saveData).then((res) => {
            if (res.code === 200) {
              this.loading = true;
              this.getPriceIsSuccess();
              this.priceTimerCount = 0;
              this.priceTimer = setInterval(() => {
                this.priceTimerCount++;
                if (this.priceTimerCount > 10) {
                  this.loading = false;
                  clearInterval(this.priceTimer);
                  handleAlert("价格保存超时，请稍后查看", "error");
                }
                this.getPriceIsSuccess();
              }, 3000);
            }
          });
        }
      });
    },
    getPriceIsSuccess() {
      this.$api.shebei
        .priceIsSuccess({ equipmentNum: this.stageOneForm.equipmentNum })
        .then((res) => {
          if (res.code === 200) {
            if (this.isWLXSRO800) {
              let successCount = 0;
              let totalCount = 0;
              // 验证纯净水 (waterNum=1)
              if (this.stageTwoForm.equipmentModel.indexOf("纯净水") !== -1) {
                totalCount++;
                const purePrice = res.data.find((item) => item.waterNum == 1);
                if (
                  purePrice &&
                  Math.abs(
                    this.stageTwoForm.hotWaterFrom.equipmentPrice -
                      purePrice.normalPrice,
                  ) < 0.01
                ) {
                  successCount++;
                }
              }
              // 验证富矿水 (waterNum=2)
              if (this.stageTwoForm.equipmentModel.indexOf("富矿水") !== -1) {
                totalCount++;
                const mineralPrice = res.data.find(
                  (item) => item.waterNum == 2,
                );
                if (
                  mineralPrice &&
                  Math.abs(
                    this.stageTwoForm.iceWaterFrom.equipmentPrice -
                      mineralPrice.normalPrice,
                  ) < 0.01
                ) {
                  successCount++;
                }
              }
              if (successCount === totalCount && totalCount > 0) {
                this.loading = false;
                clearInterval(this.priceTimer);
                handleAlert("价格保存成功", "success");
                this.$router.push({ path: "/shebei/shebeilist" });
              }
            } else {
              // 普通设备验证
              if (
                res.data &&
                res.data[0] &&
                Math.abs(
                  this.stageTwoForm.hotWaterFrom.equipmentPrice -
                    res.data[0].normalPrice,
                ) < 0.01
              ) {
                this.loading = false;
                clearInterval(this.priceTimer);
                handleAlert("价格保存成功", "success");
                this.$router.push({ path: "/shebei/shebeilist" });
              }
            }
          }
        });
    },
    // 第三阶段保存
    saveTree() {
      const imgListUpload = [];
      this.imgList.forEach((v) => {
        imgListUpload.push(v.url);
      });

      this.$api.shebei
        .saveTree({
          equipmentPlace: this.stageTreeForm.equipmentPlace,
          placeDesc: this.stageTreeForm.placeDesc,
          id: this.stageTreeForm.id,
          // futureFilterElementBeans: this.stageTreeForm
          //   .futureEquipmentVerSkuBeans,
          futureFilterElementBeans: this.stageTreeForm.filterList,
          deleteFilterElementBeans: this.deleteFilterElementBeans,
          customerFace: imgListUpload,
        })
        .then((res) => {
          if (res.code === 200) {
            handleAlert("保存成功", "success");
          }
        });
    },

    // 启用设备
    startShebeiBtn() {
      this.$api.shebei.startShebei({ id: this.id }).then((res) => {
        if (res.code === 200) {
          handleAlert("设备启用成功", "success");
          this.$router.push("/shebei/shebeilist");
        }
      });
    },

    // 选中的铺设场景
    sceneChange(val) {
      this.changjingid = val.id;
    },

    // 选中的设备模式
    changeshebeiModel(val) {
      this.shebeiModelArr = [];
      if (this.stageTwoForm.equipmentModel) {
        this.stageTwoForm.equipmentModel.map((v1) => {
          this.shebeiModelList.forEach((v2) => {
            if (v1 == v2.dictName) {
              this.shebeiModelArr.push(v2.dictId);
            }
          });
        });
      }
    },

    // 归属下拉
    getguishu() {
      this.$api.enterprise.pullList().then((res) => {
        this.guishuList = res.data;
      });
    },

    // 滤芯下拉
    getlvxin() {
      this.$api.shebei.filterList().then((res) => {
        this.lvxinList = res.data;
      });
    },

    companyNameChange() {
      // this.$api.shebei
      //   .fenrunList({ companyId: this.stageOneForm.companyName })
      //   .then((res) => {
      //     this.fenrunList = res.data;
      //   });
      this.$api.enterprise
        .enterpriseInfo({ id: this.stageOneForm.companyName })
        .then((res) => {
          if (res.code === 200) {
            this.ratio = res.data.ratio;
            this.stageOneForm.typeName = res.data.type === 1 ? "购买" : "租赁";
            if (this.stageOneForm.typeName == "租赁") {
              this.stageOneForm.guishu = "未来先生";
            } else {
              this.stageOneForm.guishu = "";
            }
          }
        });
    },

    // 当前年月日
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const currentDate = `${year}-${month}-${day}`;
      return currentDate;
    },

    // 后一百年的年月日
    getCurrentDate100() {
      const date = new Date();
      const year = date.getFullYear();
      // 计算后一百年的日期
      const futureDate = new Date(year + 100, date.getMonth(), date.getDate()); // 后一百年的日期
      const futureYear = futureDate.getFullYear();
      const futureMonth = String(futureDate.getMonth() + 1).padStart(2, "0");
      const futureDay = String(futureDate.getDate()).padStart(2, "0");
      const futureDateNew = `${futureYear}-${futureMonth}-${futureDay}`;
      return futureDateNew;
    },

    // // 分润下拉
    getfenrun() {
      if (
        this.stageOneForm.companyName &&
        this.stageOneForm.companyName.length > 0
      ) {
        this.$api.shebei
          .fenrunList({ companyId: this.futureCustomerId })
          .then((res) => {
            this.fenrunList = res.data;
          });
      } else {
        console.log("无初始归属");
      }
    },
    // 场景下拉
    getchangjing() {
      this.$api.shebei.sceneList().then((res) => {
        this.changjingList = res.data;
      });
    },

    // 购水模式选中的值
    changeModel(val) {
      this.dictIdsArr = [];
      if (this.stageTwoForm.waterModel) {
        this.stageTwoForm.waterModel.map((v1) => {
          this.buyWaterList.forEach((v2) => {
            if (v1 == v2.dictName) {
              this.dictIdsArr.push(v2.dictId);
            }
          });
        });
      }
    },

    // 设备模式
    getshebeiModel() {
      this.$api.shebei.dictList({ dictName: "设备模式" }).then((res) => {
        this.shebeiModelList = res.data[0].futureSysDictBeans;
      });
    },
    //新增档位
    addHotPrize() {
      this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.push({
        equipmentSkuInfo: "",
        price: "",
        radio: "L",
        key: Date.now(),
      });
    },
    addIcePrize() {
      this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.push({
        equipmentSkuInfo: "",
        price: "",
        radio: "L",
        key: Date.now(),
      });
    },
    //冷暖一体新增档位
    addHotPrizeTree(v, item) {
      v.futureEquipmentVerSkuPoJoList.push({
        equipmentSkuInfo: "",
        price: "",
        gearPrizeEdit: "",
        source: this.$route.query.source,
        key: Date.now,
      });
    },
    // 删除档位
    removeHot(v) {
      const index = this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.indexOf(
        v,
      );
      if (index !== 0) {
        this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.splice(
          index,
          1,
        );
        handleAlert("水量档删除成功", "success");
      } else {
        this.$message.error("至少保留一个档位！");
      }
    },

    // getTWO() {
    //   this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList = [];
    //   this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList = [];

    //   this.$route.query.list.futureEquipmentVerSkuBeans.forEach((v) => {
    //     if (v.type == 1) {
    //       this.stageTwoForm.hotWaterFrom.equipmentPrice = v.price;
    //       this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.push(v);
    //       this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.forEach(
    //         (v2) => {
    //           v2.radio = v.capacityType;
    //         }
    //       );
    //       v.equipmentSkuInfo = JSON.parse(v.equipmentSkuInfo);
    //       this.stageTwoForm.hotWaterFrom.futureEquipmentVerSkuPoJoList.forEach(
    //         (v2) => {
    //           v2.equipmentSkuInfo = v.equipmentSkuInfo.出水量;
    //         }
    //       );
    //     } else {
    //       this.stageTwoForm.iceWaterFrom.equipmentPrice = v.price;
    //       this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.push(v);
    //       this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.forEach(
    //         (v2) => {
    //           v2.radio = v.capacityType;
    //         }
    //       );
    //       v.equipmentSkuInfo = JSON.parse(v.equipmentSkuInfo);
    //       this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.forEach(
    //         (v2) => {
    //           v2.equipmentSkuInfo = v.equipmentSkuInfo.出水量;
    //         }
    //       );
    //     }
    //   });
    //   this.stageTwoForm.sceneName = this.$route.query.list.sceneName;
    //   if (this.$route.query.list.pattern) {
    //     let modelArr = this.$route.query.list.pattern.split(",");
    //     this.buyWaterList.map((v1) => {
    //       modelArr.forEach((v2) => {
    //         if (v1.dictId == v2) {
    //           this.stageTwoForm.waterModel.push(v1.dictName);
    //           this.dictIdsArr.push(v1.dictId);
    //         }
    //       });
    //     });
    //   }
    //   console.log(this.$route.query.list);
    //   if (this.$route.query.list.types) {
    //     let eqmodelArr = this.$route.query.list.types.split(",");
    //     console.log(eqmodelArr);
    //     // this.shebeiModelList.map((v1) => {
    //     eqmodelArr.forEach((v2) => {
    //       console.log(v2, "55555");
    //       if (v2 == 1) {
    //         console.log(222);
    //         this.stageTwoForm.equipmentModel.push("常温/热水");
    //         // this.shebeiModelArr.push(v1.dictId);
    //       } else {
    //         this.stageTwoForm.equipmentModel.push("冰水");
    //       }
    //     });
    //     // });
    //   }
    // },

    removeIce(v) {
      const index = this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.indexOf(
        v,
      );
      if (index !== 0) {
        this.stageTwoForm.iceWaterFrom.futureEquipmentVerSkuPoJoList.splice(
          index,
          1,
        );
        handleAlert("水量档删除成功", "success");
      } else {
        this.$message.error("至少保留一个档位！");
      }
    },

    // 阶段三===添加滤芯按钮
    addFilter() {
      this.addBtn = false;
      this.addFilterSelect = true;
    },
    //删除已添加的滤芯
    removeCurrentFilter(item, index) {
      // this.stageTreeForm.filterList.splice(index, 1);
      handleConfirm("确认删除该滤芯吗", "warning")
        .then(() => {
          var index = this.stageTreeForm.filterList.indexOf(item);
          if (index !== -1) {
            this.stageTreeForm.filterList.splice(index, 1);
          }
          // this.stageTreeForm.filterList.splice(index, 1);
          // this.stageTreeForm.futureEquipmentVerSkuBeans = this.stageTreeForm.filterList;
          this.deleteFilterElementBeans.push(item);

          handleAlert("滤芯已删除", "success");
        })
        .catch(() => {
          handleAlert("取消删除", "error");
        });
    },
    // 删除滤芯添加
    removeAdd(v) {
      this.addFilterSelect = false;
      this.addBtn = true;
    },
    // 滤芯添加确定按钮
    addSure(v) {
      if (v.value == "") {
        handleAlert("请先添加滤芯", "error");
      } else {
        this.addBtn = true;
        this.addFilterList = true;
        this.addFilterSelect = false;
        let time = new Date();
        let timeInfo =
          time.getFullYear() +
          "年" +
          time.getMonth() +
          "月" +
          time.getDate() +
          "日" +
          time.getHours() +
          ":" +
          time.getMinutes() +
          ":" +
          time.getSeconds();

        this.stageTreeForm.filterList.push({
          filterElementName: v.value,
        });

        this.lvxinList.forEach((item) => {
          if (item.filterElementName === v.value) {
            this.stageTreeForm.futureEquipmentVerSkuBeans.push(item);
          } else {
            return;
          }
        });
      }
    },
    // 更换滤芯
    changeFilter(value) {
      handleConfirm("请确认是否已完成滤芯更换？", "warning")
        .then(() => {
          handleAlert("滤芯已更换", "success");
        })
        .catch(() => {
          handleAlert("取消更换", "error");
        });
    },

    // 下一步按钮
    next_go(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.oneSave();
          this.active++;
          if (this.active === 3) {
            if (this.$route.query.list.futureProcessId >= 5) {
              this.saveTree();
            }
            this.$api.shebei.shebeiInfo({ id: this.id }).then((res) => {
              this.stageFourForm = res.data;
              let buyWaterStr = this.stageFourForm.pattern;
              let buyWaterArr = buyWaterStr.split(",");
              let buyWaterNewArr = buyWaterArr.map((v) => {
                if (v == 1) {
                  return "电子水卡购水";
                } else if (v == 2) {
                  return "实体水卡购水";
                } else if (v == 3) {
                  return "扫码零售购水";
                } else {
                  return;
                }
              });
              this.fourBuyWater = buyWaterNewArr.join();

              let typeStr = this.stageFourForm.types;
              let typeArr = typeStr.split(",");
              let typeNewArr = typeArr.map((v) => {
                if (v == 1) {
                  return "温水/热水";
                } else if (v == 3) {
                  return "冰水";
                } else {
                  return;
                }
              });
              this.fourTypes = typeNewArr.join();
              this.fourHotInfo = [];
              this.fourIceInfo = [];
              res.data.futureEquipmentVerSkuBeans.forEach((v, i) => {
                if (v.type == 1) {
                  this.fourHotInfo.push(v);
                  this.fourHotInfo.forEach((v2) => {
                    let obj = v2.equipmentSkuInfo;

                    v2.yield = `${JSON.parse(obj).出水量}${v2.capacityType}`;
                  });
                } else if (v.type == 3) {
                  this.fourIceInfo.push(v);
                  this.fourIceInfo.forEach((v2) => {
                    let obj = v2.equipmentSkuInfo;
                    v2.yield = `${JSON.parse(obj).出水量}${v2.capacityType}`;
                  });
                }
              });
            });
          } else if (this.active === 1) {
            console.log(1);
          } else if (this.active === 2) {
            console.log(this.$route.query.list, "数字");
            if (this.$route.query.list.futureProcessId >= 4) {
              this.saveTwo();
            }

            this.stageTreeForm.equipmentPlace = this.$route.query.list.equipmentPlace;
            this.stageTreeForm.placeDesc = this.$route.query.list.placeDesc;

            this.stageTreeForm.qrCode = this.$route.query.list.codeMessage;

            this.stageTreeForm.filterList = this.$route.query.list.futureFilterElementBeans;
          }
        }
      });
    },
    // 上一步
    upGo() {
      this.active--;
      if (this.active === 3) {
        this.$api.shebei.shebeiInfo({ id: this.id }).then((res) => {
          this.stageFourForm = res.data;
          let buyWaterStr = this.stageFourForm.pattern;
          let buyWaterArr = buyWaterStr.split(",");
          let buyWaterNewArr = buyWaterArr.map((v) => {
            if (v == 1) {
              return "电子水卡购水";
            } else if (v == 2) {
              return "实体水卡购水";
            } else if (v == 3) {
              return "扫码零售购水";
            } else {
              return;
            }
          });
          this.fourBuyWater = buyWaterNewArr.join();

          let typeStr = this.stageFourForm.types;
          let typeArr = typeStr.split(",");
          let typeNewArr = typeArr.map((v) => {
            if (v == 1) {
              return "温水/热水";
            } else if (v == 3) {
              return "冰水";
            } else {
              return;
            }
          });
          this.fourTypes = typeNewArr.join();
          this.fourHotInfo = [];
          this.fourIceInfo = [];
          res.data.futureEquipmentVerSkuBeans.forEach((v, i) => {
            if (v.type == 1) {
              this.fourHotInfo.push(v);
              this.fourHotInfo.forEach((v2) => {
                let obj = v2.equipmentSkuInfo;

                v2.yield = `${JSON.parse(obj).出水量}${v2.capacityType}`;
              });
            } else if (v.type == 3) {
              this.fourIceInfo.push(v);
              this.fourIceInfo.forEach((v2) => {
                let obj = v2.equipmentSkuInfo;
                v2.yield = `${JSON.parse(obj).出水量}${v2.capacityType}`;
              });
            }
          });
        });
      } else if (this.active === 1) {
      } else if (this.active === 2) {
        // this.stageTreeForm.equipmentPlace = this.$route.query.list.equipmentPlace;
        this.stageTreeForm.placeDesc = this.$route.query.list.placeDesc;

        this.stageTreeForm.qrCode = this.$route.query.list.codeMessage;

        this.stageTreeForm.filterList = this.$route.query.list.futureFilterElementBeans;
      }
    },
    // 删除冷热温模式
    removeModel(v) {
      var index = this.iceHotModelArr.indexOf(v);
      handleConfirm("确认删除该模式吗?", "info")
        .then(() => {
          if (index !== -1) {
            this.iceHotModelArr.splice(index, 1);
          }
        })
        .catch(() => {
          return;
        });
    },
    // 取消
    cancelBtn() {
      // handleConfirm("确认取消编辑吗？", "warning")
      //   .then(() => {
      this.$router.push({
        path: "/shebei/shebeilist",
        query: {
          futureBatchId: this.futureBatchId,
          createTime: this.createTime,
        },
      });
      // })
      // .catch(() => {
      //   return;
      // });
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt2M;
    },

    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          // this.stageTreeForm.equipmentPhoto = URL.createObjectURL(params.file);
          // this.changeHeadImgform.headUrl = res.data[0];
          this.stageTreeForm.equipmentPhoto = res.data[0];
          this.imgList.push({
            url: res.data[0],
          });
          // this.imgList.forEach((v) => {
          //   console.log(v, "哦哦哦");
          //   this.imgListUpload.push(v.url);
          // });
          // this.imgListUpload = this.imgListUpload.filter(
          //   (item, index, array) => {
          //     return array.indexOf(item) === index;
          //   }
          // );
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },

    goOn() {
      this.$router.push({
        path: "/shebei/shebeilist",
        query: {
          futureBatchId: this.futureBatchId,
          createTime: this.createTime,
        },
      });
    },

    handleRemove(file, fileList) {
      this.imgList = fileList;
    },

    handlePictureCardPreview(file) {
      this.stageTreeForm.equipmentPhoto = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__label {
  color: var(--text-main);
}
.selectWater {
  .el-button {
    width: 100px;
  }
}
.hotPrize,
.icePrize {
  .inp {
    width: 30%;
  }
  .quantity {
    width: 100px;
  }
}
.waterYield {
  // .el-form-item {
  //   float: left;
  // }
  .el-select {
    width: 100px;
  }
}
.eaitPrizeInp {
  width: 100px;
}
.temperature {
  .el-input,
  .el-select {
    width: 30%;
    margin-left: 15px;
  }
}
.stageTree {
  .el-select {
    width: 50%;
  }
  .filter-input {
    width: 20%;
  }
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed var(--input-border);
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  width: 150px;
  height: 150px;
  position: relative;
  .avatar-uploader-icon {
    font-size: 28px;
    color: var(--text-sub);
    text-align: center;
    position: absolute;
  }
}

/deep/ .avatar-uploader .el-upload:hover .el-icon-plus {
  color: var(--accent);
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: var(--accent);
}
.scan-box {
  border: 1px dashed var(--input-border);
  border-radius: 6px;
  overflow: hidden;
  width: 150px;
  height: 150px;
  .avatar-uploader-icon {
    font-size: 28px;
    color: var(--text-sub);
    text-align: center;
    height: 150px !important;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/ .el-descriptions__title {
  color: var(--accent);
}
/deep/ .el-descriptions-item__content {
  color: var(--accent);
}
.el-descriptions {
  width: 40%;
}

.iceHotModel:hover {
  background: var(--accent);
  border: 1px solid var(--accent);
  cursor: pointer;
  box-shadow: 2px 2px 2px 2px #1989fa;
  .nameTitle {
    font-weight: 600;
    color: #fff;
  }
  .modelTitle {
    font-weight: 600;
    margin-top: 15px;
    color: #fff;
  }
}
.iceHotModel {
  padding: 10px 50px;
  border: 1px solid var(--input-border);
  margin-top: 10px;
  position: relative;
  box-shadow: 2px 2px 2px 2px #ccc;
  margin-right: 15px;
  .cha {
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
    color: red;
    border: 1px solid red;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    text-align: center;
    line-height: 20px;
  }
  .nameTitle {
    font-weight: 600;
  }
  .modelTitle {
    font-weight: 600;
    margin-top: 15px;
  }
}
.lengrewenmoshi {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
</style>
